// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2duUG","approved":"Status_approved__FUlvo","rejected":"Status_rejected__1D9uX","expired":"Status_expired__2jMJa","label":"Status_label__1C1_r"};